const R = require('ramda');
const { failProofAssign } = require('../utils');
const ArchitectureElement = require('./ArchitectureElement');
class AdAccount extends ArchitectureElement {
  constructor(obj) {
    super();
    this.isReportsLoaded = false;
    this.isGraphLoaded = false;
    this.updateData(obj);
  }

  updateData(obj) {
    if (!obj) return;
    failProofAssign(this, R.omit(['id', 'architecture'], obj));
  }

  get channel() {
    return this._channel;
  }

  set channel(channel) {
    this._channel = channel;
  }

  get id() {
    return `${this.channel}:adAccount:${this.channelId}`;
  }

  get level() {
    return 'adAccount';
  }

  get campaigns() {
    const campaignIds = this.getChildElementIds();
    return campaignIds.map(id => this.architecture.campaignsById[id]);
  }

  get children() {
    return this.campaigns;
  }

  getArchitectureFilter(level = 'adAccount') {
    const filterObj = {
      adAccount: R.pick(['channelId', 'channel', 'currency', 'havePixel'], this),
    };
    if (level !== 'adAccount') {
      const campaigns = this.campaigns;
      filterObj.campaigns = campaigns.map(R.pick(['channelId', 'appCampaignSetting', 'bidStrategy']));
      if (level !== 'campaign') {
        const adSets = campaigns.flatMap(campaign => campaign.adSets);
        filterObj.adSets = adSets.map(R.pick(['channelId', 'channelCampaignId']));
        if (level !== 'adSet') {
          const ads = adSets.flatMap(adSet => adSet.ads);
          filterObj.ads = ads.map(R.pick(['channelId', 'channelCampaignId', 'channelAdSetId']));
        }
      }
    }
    return filterObj;
  }

  fill({ campaignsById }) {
    this.campaigns = this.campaignIds.map(id => campaignsById[id]);
    this.campaigns.map(campaign => (campaign.adAccount = this));
  }

  format() {
    return {
      adAccountName: this.name,
      adAccountId: this.channelId,
      channel: this.channel,
    };
  }

  getJSON() {
    const campaignIds = this.getChildElementIds();
    return { ...R.omit(['architecture', 'FEFormat', '_channel'], this), channel: this.channel, campaignIds };
  }
  toJSON() {
    return { ...this, architecture: undefined };
  }
}

module.exports = AdAccount;
